import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.qadataset.qainstruct');
import { OnInit, Input, Component } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

declare const wiz: any;

@Component({
    selector: 'wiz-portal-qadataset-qainstruct',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.qadataset.qainstruct/view.scss */
@charset "UTF-8";
/* Grid 시스템 */
.grid-cols-14 {
  grid-template-columns: repeat(14, minmax(0, 1fr));
}

.grid-cols-15 {
  grid-template-columns: repeat(15, minmax(0, 1fr));
}

.grid-cols-16 {
  grid-template-columns: repeat(16, minmax(0, 1fr));
}

.grid-cols-18 {
  grid-template-columns: repeat(18, minmax(0, 1fr));
}

.grid-cols-20 {
  grid-template-columns: repeat(20, minmax(0, 1fr));
}

/* 줄 제한 */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 애니메이션 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animate-fadeIn {
  animation: fadeIn 0.2s ease-out;
}

/* 부드러운 전환 */
* {
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}`],
})
export class PortalQadatasetQainstructComponent implements OnInit {

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    @Input() title: any;

    // ==========================
    // 뷰 상태 (목록 / 검수결과)
    // ==========================
    public activeTab: 'list' | 'review' = 'list';

    // ==========================
    // 목록 전용 상태값
    // ==========================
    public datasetList: any[] = [];   // 그룹 리스트
    public vectordbList: any[] = [];  // VectorDB 리스트
    public maxReviewerCount: number = 1;
    public modalOpen: boolean = false;

    public newGroup = { id: "", vectordb_id: "", group_name: "" };
    public selectedIds: string[] = [];

    // 목록 페이지네이션
    public listPage: number = 1;
    public listPageSize: number = 10;

    // 그룹 이름 수정 모달 상태 (클래스 속성으로 추가)
    public showRenameGroupModal: boolean = false;
    public renameGroupTarget: any = null;
    public renameGroupName: string = '';
    public renameGroupError: string = '';

    // ==========================
    // 검수 결과(통계) 화면 상태
    // ==========================
    public selectedGroup: any = null;

    public reviewList: any[] = [];
    public reviewListTotal: number = 0;

    public reviewPage: number = 1;
    public reviewPageSize: number = 6;

    public selectedReview: any = null;
    public openedReviewIndex: number | null = null;

    public allReviews: any[] = [];
    public reviewStats: any = {};
    public totalReviewPages: number = 1;
    public userSummary: any[] = [];
    public perUserReview: any[] = [];

    private reviewStatusChart: any = null;
    private reviewScoreChart: any = null;

    selectedReviewerIds = new Set<string>();
    randomAssignedUsers: any[] = [];

    // ==========================
    // Q&A 데이터셋 사용자 할당 
    // ==========================

    // 전체 사용자 목록 (API로 불러온다고 가정)
    public allUsers: any[] = [];

    // 검색용 텍스트
    public userSearch: string = "";

    // 필터된 자동완성 목록
    public filteredUsers: any[] = [];

    // 최종 선택된 사용자들
    public selectedUsers: any[] = [];

    // 드롭다운 표시 여부
    public dropdownOpen: boolean = false;

    // 전체 선택 여부
    public isAllSelected: boolean = false;

    // row 체크박스 클릭 시 실행
    public async onCheckedChange() {
        this.selectedIds = this.datasetList
            .filter(r => r.checked)
            .map(r => r.id);

        await this.service.render();
    }

    public get hasSelectedGroups(): boolean {
        return this.datasetList.some(r => r.checked);
    }

    public get isPageAllSelected(): boolean {
        if (this.pagedDatasetList.length === 0) return false;
        return this.pagedDatasetList.every(r => r.checked);
    }

    public async updateSelectedState() {
        // 값만 읽으면 Angular가 자동으로 getter 다시 계산함
        await this.service.render();
    }

    // row 선택 처리
    public async toggleSelect(id: string, event: any) {
        const checked = event.target.checked;

        this.datasetList = this.datasetList.map(r =>
            r.id === id ? { ...r, checked } : r
        );

        this.isAllSelected = this.datasetList.every(r => r.checked);
        this.selectedIds = this.datasetList.filter(r => r.checked).map(r => r.id);
        await this.service.render();
    }


    public debugCheck(row: any) {
    }


    public async toggleSelectAll(event: any) {
        const checked = event.target.checked;

        // 현재 페이지에 보이는 항목들만 체크/해제
        this.pagedDatasetList.forEach(pageRow => {
            // datasetList에서 동일한 id를 가진 항목을 찾아서 업데이트
            const targetRow = this.datasetList.find(r => r.id === pageRow.id);
            if (targetRow) {
                targetRow.checked = checked;
            }
        });

        // selectedIds 업데이트
        this.selectedIds = this.datasetList
            .filter(r => r.checked)
            .map(r => r.id);

        await this.service.render();
    }

    // input에서 포커스 빠졌을 때 닫기
    public onUserInputBlur() {
        setTimeout(() => {
            this.dropdownOpen = false;
            this.service.render();
        }, 0);
    }

    // 드롭다운 클릭 시 blur보다 먼저 실행되게
    public onUserMouseDown(event: MouseEvent) {
        event.preventDefault();
    }


    // 자동완성 필터링
    public async filterUsers() {
        const q = (this.userSearch || "").toLowerCase();

        if (!q) {
            this.filteredUsers = [...this.allUsers];
            return;
        }

        this.filteredUsers = this.allUsers.filter(u =>
            u.name.toLowerCase().includes(q) ||
            u.email.toLowerCase().includes(q)
        );
        await this.service.render();
    }


    // 사용자 추가
    public async addUser(user: any) {
        // 중복 추가 방지
        if (this.selectedUsers.find(u => u.id === user.id)) return;

        this.selectedUsers.push(user);
        this.userSearch = "";
        this.dropdownOpen = false;
        await this.service.render();
    }

    // 사용자 제거
    public async removeUser(u: any) {
        this.selectedUsers = this.selectedUsers.filter(x => x.id !== u.id);
        this.selectedReviewerIds.delete(u.id);

        this.randomAssignedUsers = [];

        await this.service.render();
    }

    // 모달 닫힐 때 자동완성 닫기
    public closeDropdown() {
        this.dropdownOpen = false;
    }

    // ==========================
    // lifecycle
    // ==========================
    public async ngOnInit() {
        this.service.init();
        this.service.auth.allow();

        this.loadVectorDBList();
        this.loadDatasetList();
        this.service.render();

        // this.allUsers = await this.loadUsers();  // TODO: API 연결
        this.filteredUsers = [...this.allUsers];
        this.loadUsers();
    }

    async loadUsers() {
        const res = await wiz.call("list_users");
        this.allUsers = res.data?.users || [];
        this.filteredUsers = [...this.allUsers];
        await this.service.render();
    }

    // 포커스 되면 드롭다운 열기
    public async openUserDropdown() {
        this.dropdownOpen = true;
        this.filteredUsers = [...this.allUsers];
        await this.service.render();
    }

    // ==========================
    // Util
    // ==========================
    private makeId(): string {
        return Math.random().toString(36).substring(2, 10);
    }

    // ==========================
    // Vector DB List Load
    // ==========================
    public async loadVectorDBList() {
        const res = await wiz.call("get_vector_dbs", {});
        this.vectordbList = Array.isArray(res) ? res : (res?.data || []);
        await this.service.render();
    }

    // ==========================
    // Dataset(그룹) List Load
    // ==========================
    public async loadDatasetList() {
        const res = await wiz.call("get_group_list", {});

        let list = Array.isArray(res) ? res : (res?.data || []);

        // progress 기본값 보정
        this.datasetList = list.map(row => ({
            ...row,
            checked: false,
            progress: row.progress ?? 0,
            review_pending: row.review_pending ?? 0,
        }));
        await this.service.render();
    }


    // ==========================
    // 그룹 생성 모달
    // ==========================
    public async openGroupCreateModal() {
        this.modalOpen = true;
        this.maxReviewerCount = 1;

        this.newGroup = {
            id: this.makeId(),
            vectordb_id: "",
            group_name: ""
        };

        this.loadUsers();
        this.filteredUsers = [...this.allUsers];

        this.userSearch = "";
        this.dropdownOpen = false;

        await this.service.render();
    }


    public async closeModal() {
        // 사용자 배정 관련 상태만 초기화
        this.selectedUsers = [];
        this.randomAssignedUsers = [];
        this.selectedReviewerIds.clear();

        this.userSearch = "";
        this.dropdownOpen = false;

        this.filteredUsers = [...this.allUsers];

        this.modalOpen = false;
        await this.service.render();
    }

    public async createGroup() {
        if (!this.newGroup.vectordb_id) {
            alert("VectorDB를 선택하세요.");
            return;
        }
        if (!this.newGroup.group_name) {
            alert("그룹명을 입력하세요.");
            return;
        }

        const assigned_user_ids = this.selectedUsers.map(u => u.id);

        const res = await wiz.call("create_group", {
            vectordb_id: this.newGroup.vectordb_id,
            group_name: this.newGroup.group_name,
            assigned_user_ids: JSON.stringify(assigned_user_ids)
        });
        if (res?.code === 200) {
            alert("그룹이 생성되었습니다!");
            this.selectedUsers = [];
            this.userSearch = "";
            this.filteredUsers = [...this.allUsers];
            this.closeModal();
            this.modalOpen = false;
            await this.loadDatasetList();
            await this.service.render();
        } else {
            alert(res?.error || "그룹 생성 실패");
        }
        await this.service.render();
    }
    // ==========================
    // 목록 페이지네이션
    // ==========================
    public get totalListPages(): number {
        const total = Math.ceil(this.datasetList.length / this.listPageSize);
        return total > 0 ? total : 1;
    }

    public get pagedDatasetList(): any[] {
        const start = (this.listPage - 1) * this.listPageSize;
        return this.datasetList.slice(start, start + this.listPageSize);
    }

    public async prevListPage() {
        if (this.listPage > 1) {
            this.listPage--;
            // 페이지 이동 시 체크 상태 초기화
            this.clearPageSelections();
            await this.service.render();
        }
    }

    public async nextListPage() {
        if (this.listPage < this.totalListPages) {
            this.listPage++;
            // 페이지 이동 시 체크 상태 초기화
            this.clearPageSelections();
            await this.service.render();
        }
    }

    // 현재 페이지의 체크 상태 초기화
    private clearPageSelections() {
        this.pagedDatasetList.forEach(pageRow => {
            const targetRow = this.datasetList.find(r => r.id === pageRow.id);
            if (targetRow) {
                targetRow.checked = false;
            }
        });
        // selectedIds에서도 제거
        const pageIds = this.pagedDatasetList.map(r => r.id);
        this.selectedIds = this.selectedIds.filter(id => !pageIds.includes(id));
    }

    // ==========================
    // 그룹 삭제
    // ==========================

    public async deleteGroups() {
        if (this.selectedIds.length === 0) {
            alert("선택된 항목이 없습니다");
            return;
        }
        const confirmMsg = `선택된 ${this.selectedIds.length}개의 그룹을 삭제하시겠습니까?\n\n삭제된 데이터는 복구할 수 없습니다.`;

        if (!confirm(confirmMsg)) {
            return;
        }
        const query = encodeURIComponent(JSON.stringify(this.selectedIds));
        const url = wiz.url("delete_group") + `?ids=${query}`;

        const res = await fetch(url, { method: "POST" });
        const json = await res.json();

        this.datasetList = this.datasetList.filter(
            r => !this.selectedIds.includes(r.id)
        );

        if (this.listPage > this.totalListPages) {
            this.listPage = this.totalListPages > 0 ? this.totalListPages : 1;
        }

        this.selectedIds = [];

        await this.service.render();
    }


    // ==========================
    // 그룹 클릭 → verify 페이지로 이동 (개인 검수 화면)
    // ==========================
    public goToVerify(groupId: string) {
        this.router.navigateByUrl(`/ui/qainstruct/${groupId}`);
    }
    // ==========================
    // 버튼 클릭 → reviewlog 페이지로 이동 (개인 검수 내역 화면)
    // ==========================
    public goToReviewLog(id: string) {
        if (!id) return;
        this.router.navigateByUrl(`/ui/qainstruct/${id}/reviewlog`);
    }

    public async openReviewPage(row: any) {
        let groupId: string | null = null;

        // 1) row 타입별 group_id 판별
        if (typeof row === "string") {
            groupId = row;
        }
        else if (typeof row === "object" && row !== null) {
            groupId =
                row.id ||
                row.group_id ||
                row.groupId ||
                row.gid ||
                row.group?.id ||
                null;
        }

        // 유효성 체크
        if (!groupId) {
            alert("group_id를 찾을 수 없습니다. 관리자에게 문의하세요.");
            return;
        }

        // 2) 그룹 상세 정보 다시 불러오기
        const detailRes = await wiz.call("get_group_detail", { id: groupId });

        if (!detailRes || detailRes.code !== 200) {
            alert("그룹 상세 정보를 불러오지 못했습니다.");
            return;
        }

        this.selectedGroup = detailRes.data;

        // 3) 사용자 요약
        const summaryRes = await wiz.call("user_summary", { group_id: groupId });
        this.userSummary = summaryRes?.data?.users || [];

        // 4) 초기화
        this.activeTab = 'review';
        this.reviewPage = 1;
        this.openedReviewIndex = null;
        this.selectedReview = null;

        // 5) 리뷰 리스트 로딩
        await this.loadReviewList(groupId);
        await this.service.render();

        // 6) 차트 렌더링
        requestAnimationFrame(() => {
            this.renderReviewCharts();
        });
    }



    public async goBackToList() {
        // 목록 화면으로 복귀
        this.activeTab = 'list';
        this.selectedGroup = null;
        this.selectedReview = null;
        this.openedReviewIndex = null;

        // 차트 정리
        if (this.reviewStatusChart) this.reviewStatusChart.destroy();
        if (this.reviewScoreChart) this.reviewScoreChart.destroy();
        this.reviewStatusChart = null;
        this.reviewScoreChart = null;

        await this.service.render();
    }

    // ==========================
    // 검수 결과 데이터 로딩
    // ==========================
    private async loadReviewList(groupId: string) {
        // 1) 전체 리뷰 데이터 호출
        const res = await wiz.call("get_review_list", {
            group_id: groupId,
            page: 1,
            limit: 999999
        });

        const data = res?.data || res;

        // 2) 전체 QA 리스트 + 전체 리뷰 저장
        this.reviewList = data.items || [];
        this.allReviews = data.reviews_all || [];
        this.reviewStats = data.review_stats || {};
        this.reviewListTotal = this.reviewList.length;
        this.totalReviewPages = this.totalReviewPagesCalc;

        this.reviewPage = 1;
        this.openedReviewIndex = null;

        // 3) 첫 번째 리뷰 자동 선택
        if (this.reviewList.length > 0) {
            this.selectedReview = this.reviewList[0];
        } else {
            this.selectedReview = null;
            this.perUserReview = [];
            return;
        }

        // 4) 선택된 QA에 해당하는 리뷰만 필터링
        this.allReviews = (data.reviews_all || []).filter(
            r => r.qa_id === this.selectedReview.id
        );

        // 5) 사용자별 진행 상태 계산
        this.buildPerUserProgress();
    }


    public get reviewTotalPages(): number {
        return Math.ceil(this.reviewList.length / this.reviewPageSize);
    }

    public get pagedReviewList(): any[] {
        const start = (this.reviewPage - 1) * this.reviewPageSize;
        return this.reviewList.slice(start, start + this.reviewPageSize);
    }

    public get totalReviewPagesCalc(): number {
        return Math.ceil(this.reviewList.length / this.reviewPageSize) || 1;
    }

    public async prevReviewPage() {
        if (this.reviewPage > 1) {
            this.reviewPage--;
            this.openedReviewIndex = null;
            this.selectedReview = null;
            await this.service.render();
        }
    }

    public async nextReviewPage() {
        if (this.reviewPage < this.reviewTotalPages) {
            this.reviewPage++;
            this.openedReviewIndex = null;
            this.selectedReview = null;
            await this.service.render();
        }
    }

    public async onReviewRowClick(item: any, idx: number) {
        this.selectedReview = item;
        this.openedReviewIndex = this.openedReviewIndex === idx ? null : idx;

        // 클릭된 질문에 대한 전체 리뷰만 필터링
        const gid =
            this.selectedGroup?.id ||
            this.selectedGroup?.group_id ||
            this.selectedGroup?.groupId ||
            this.selectedGroup;

        const res = await wiz.call("get_review_list", {
            group_id: gid
        });

        const all = res?.data?.reviews_all || res?.reviews_all || [];
        this.allReviews = all.filter(r => r.qa_id === item.id);

        this.buildPerUserProgress();
        await this.service.render();

        requestAnimationFrame(() => {
            this.renderReviewCharts();
        });
    }

    // ==========================
    // Chart.js 렌더링
    // ==========================
    private renderReviewCharts() {
        // 선택된 리뷰가 없으면 차트 초기화
        if (!this.selectedReview) {
            if (this.reviewStatusChart) this.reviewStatusChart.destroy();
            return;
        }

        if (!this.allReviews || !Array.isArray(this.allReviews)) {
            return;
        }

        // 이 QA의 모든 리뷰 데이터
        const reviewsForThisQA = this.allReviews;

        // 배정된 사용자 수
        const assignedTotal = this.selectedReview?.progress?.assigned_total || 0;

        // 실제 검수한 사용자(중복 제거)
        const completedUsers = new Set(
            reviewsForThisQA
                .filter(r => r.user_id && [1, 0, -1].includes(r.accept))  // 안전 필터링
                .map(r => r.user_id)
        );

        const completedCount = completedUsers.size;

        // 승인 / 반려 개수
        const approved = reviewsForThisQA.filter(r => r.accept === 1).length;
        const rejected = reviewsForThisQA.filter(r => r.accept === -1).length;
        const neutral = reviewsForThisQA.filter(r => r.accept === 0).length;

        // 캔버스 찾기
        const statusCanvas = document.getElementById("reviewStatusChart") as HTMLCanvasElement;
        if (!statusCanvas) return;

        const statusCtx = statusCanvas.getContext("2d");
        if (!statusCtx) return;

        // 기존 차트 제거
        if (this.reviewStatusChart) this.reviewStatusChart.destroy();

        // 도넛 차트 생성
        this.reviewStatusChart = new Chart(statusCtx, {
            type: 'doughnut',
            data: {
                labels: ['승인', '반려', '중립'],
                datasets: [{
                    data: [approved, rejected, neutral],
                    backgroundColor: [
                        'rgba(90,178,255,0.85)',   // 승인
                        'rgba(255,120,120,0.85)', // 반려
                        'rgba(165,120,255,0.85)'  // 미검수(보라)
                    ],
                    borderColor: [
                        'rgba(90,178,255,1)',
                        'rgba(255,120,120,1)',
                        'rgba(165,120,255,1)'
                    ],
                    borderWidth: 2,
                    hoverOffset: 10
                }]
            },
            options: {
                cutout: '55%',
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            color: '#444',
                            font: { size: 13, weight: '500' },
                            padding: 20
                        }
                    },
                    tooltip: {
                        backgroundColor: 'rgba(30,30,30,0.85)',
                        titleColor: '#fff',
                        bodyColor: '#eee',
                        padding: 12,
                        borderWidth: 0,
                        displayColors: false
                    }
                }
            }
        });
    }

    private buildPerUserProgress() {
        if (!this.selectedReview || !this.allReviews) {
            this.perUserReview = [];
            return;
        }

        const reviewsForThisQA = this.allReviews;
        const assignedUsers = JSON.parse(this.selectedReview.assigned_user_ids || "[]");

        this.perUserReview = assignedUsers.map(uid => {

            // 1) 이 사용자가 남긴 모든 리뷰 가져오기
            const userReviews = reviewsForThisQA
                .filter(r => r.user_id === uid)
                .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

            // 2) 리뷰 row 자체가 없음 → 미검수
            if (userReviews.length === 0) {
                return {
                    user_id: uid,
                    user_name: this.userSummary.find(u => u.user_id === uid)?.user_name || uid,
                    status: "미검수",
                    progress: 0
                };
            }

            // 3) 리뷰는 존재하는데 accept가 null → 중립
            const latest = userReviews[userReviews.length - 1];

            let status = "중립";

            if (latest.accept === 1) {
                status = "승인";
            } else if (latest.accept === -1) {
                status = "반려";
            } else if (latest.accept === 0) {
                status = "중립";
            }

            return {
                user_id: uid,
                user_name: this.userSummary.find(u => u.user_id === uid)?.user_name || uid,
                status,
                progress: 100
            };
        });
    }

    //  qa 마감
    public async closeQA(row: any) {

        const groupId = row.id || row.group_id;

        if (!groupId) {
            alert("group_id를 찾을 수 없습니다. 관리자에게 문의하세요.");
            return;
        }

        if ((row.progress || 0) < 100) return;

        if (!confirm("이 QA 세트를 마감하시겠습니까?")) return;

        const res = await wiz.call("close_group", { group_id: groupId });

        if (res?.code === 200) {
            alert("QA 세트가 성공적으로 마감되었습니다.");
            await this.loadDatasetList();
            await this.service.render();
        } else {
            alert(res?.error || "마감 실패");
        }
    }

    downloadCsv(row: any, options?: { onlyApproved?: boolean }) {
        const params = new URLSearchParams({
            group_id: row.id,
            onlyAccepted: options?.onlyApproved ? '1' : '0'
        }).toString();

        window.open(
            `/wiz/api/portal.qadataset.qainstruct/qa_csv_download?${params}`,
            '_blank'
        );
    }

    async toggleCsvMenu(row: any, event: MouseEvent) {
        event.stopPropagation();

        row._csvMenuOpen = !row._csvMenuOpen;
        this.service.render();
    }

    downloadCsvAll(row: any) {
        row._csvMenuOpen = false;
        this.downloadCsv(row, { onlyApproved: false });
    }

    downloadCsvApproved(row: any) {
        row._csvMenuOpen = false;
        this.downloadCsv(row, { onlyApproved: true });
    }

    async assignRandomUsers() {
        const res = await wiz.call("assign_random_reviewers", {
            limit: this.maxReviewerCount
        });
        const reviewers = res?.data?.reviewers || [];

        this.selectedUsers = [];
        this.selectedReviewerIds.clear();

        reviewers.forEach((u: any) => {
            this.selectedUsers.push({
                id: u.id,
                name: u.name,
                email: u.email || ""
            });
            this.selectedReviewerIds.add(u.id);
        });

        this.randomAssignedUsers = reviewers;

        await this.service.render();
    }


    // 그룹 이름 수정 모달 열기
    public openRenameGroupModal(row: any) {
        this.renameGroupTarget = row;
        this.renameGroupName = row.group_name;
        this.renameGroupError = '';
        this.showRenameGroupModal = true;
        this.service.render();
    }

    // 그룹 이름 수정 모달 닫기
    public closeRenameGroupModal() {
        this.showRenameGroupModal = false;
        this.renameGroupTarget = null;
        this.renameGroupName = '';
        this.renameGroupError = '';
        this.service.render();
    }

    // 그룹 이름 수정 확정
    public async confirmRenameGroup() {
        const newName = (this.renameGroupName || '').trim();
        
        if (!newName) {
            this.renameGroupError = '새 이름을 입력해 주세요.';
            await this.service.render();
            return;
        }
        
        if (newName === this.renameGroupTarget.group_name) {
            this.closeRenameGroupModal();
            return;
        }
        
        try {
            const res: any = await wiz.call('rename_group', {
                group_id: this.renameGroupTarget.id,
                new_name: newName
            });
            
            if (res && res.code === 200) {
                this.closeRenameGroupModal();
                await this.loadDatasetList();
                await this.service.render();
            } else {
                this.renameGroupError = res?.error || '이름 변경에 실패했습니다.';
                await this.service.render();
            }
        } catch (e) {
            this.renameGroupError = '이름 변경 중 오류가 발생했습니다.';
            await this.service.render();
        }
    }
}

export default PortalQadatasetQainstructComponent;